module.exports = __webpack_public_path__ + "static/media/bg.eb293bce.mp4";